import type { ErrorEvent, EventHint, Breadcrumb, BreadcrumbHint } from '@sentry/angular';

const SENSITIVE_HEADER_NAMES = new Set([
  'authorization',
  'cookie',
  'set-cookie',
  'x-api-key',
  'x-auth-token',
  'proxy-authorization'
]);

const FILTERED = '[Filtered]';

function scrubHeaderRecord(headers: Record<string, string>): Record<string, string> {
  const result = { ...headers };
  for (const key of Object.keys(result)) {
    if (SENSITIVE_HEADER_NAMES.has(key.toLowerCase())) {
      result[key] = FILTERED;
    }
  }
  return result;
}

export function scrubSentryEvent(event: ErrorEvent, _hint: EventHint): ErrorEvent | null {
  if (event.request?.headers) {
    event.request.headers = scrubHeaderRecord(event.request.headers);
  }

  if (event.contexts) {
    for (const ctx of Object.values(event.contexts)) {
      if (ctx && typeof ctx === 'object' && 'headers' in ctx && ctx['headers'] && typeof ctx['headers'] === 'object') {
        ctx['headers'] = scrubHeaderRecord(ctx['headers'] as Record<string, string>);
      }
    }
  }

  return event;
}

export function scrubSentryBreadcrumb(breadcrumb: Breadcrumb, _hint?: BreadcrumbHint): Breadcrumb | null {
  if (breadcrumb.data) {
    for (const key of ['headers', 'request_headers', 'response_headers'] as const) {
      if (breadcrumb.data[key] && typeof breadcrumb.data[key] === 'object') {
        breadcrumb.data[key] = scrubHeaderRecord(breadcrumb.data[key] as Record<string, string>);
      }
    }
  }
  return breadcrumb;
}
